import { render, staticRenderFns } from "./AddPill.vue?vue&type=template&id=533e2026&scoped=true"
import script from "./AddPill.vue?vue&type=script&lang=js"
export * from "./AddPill.vue?vue&type=script&lang=js"
import style0 from "./AddPill.vue?vue&type=style&index=0&id=533e2026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e2026",
  null
  
)

export default component.exports